<template>
  <CModal
    title="แก้ไขสิทธิ์ผู้ใช้"
    :show.sync="isShow"
    :closeOnBackdrop="false"
    @update:show="closeModal"
    centered
  >
    <CRow>
      <CCol sm="12">
        <CSelect
          label="สิทธิ์การใช้งานระบบ"
          :options="role"
          :horizontal="{ label: 'col-sm-4', input: 'col-sm-8' }"
          :value.sync="info.statusName"
        />
      </CCol>
    </CRow>

    <template slot="footer">
      <CButton color="secondary" variant="outline" @click="cancle">
        ยกเลิก
      </CButton>
      <CButton color="success" @click="confirm" title="ปุ่มยันยันการแก้ไข">
        บันทึกการแก้ไข
      </CButton>
    </template>
  </CModal>
</template>

<script>
import apiUser from '@/apis/user'

export default {
  name: 'UserEditModal',
  props: {
    onComplete: Function
  },
  data() {
    return {
      isShow: false,
      role: [
        { value: 'Normal', label: 'อาสาสมัคร RFB' },
        { value: 'Admin', label: 'แอดมิน' },
        { value: 'Blind', label: 'สมาชิก TAB 1414 Plus' }
      ],
      info: {},
      infoUpdate: {
        id: '',
        status: 1
      }
    }
  },
  methods: {
    show(info) {
      this.isShow = true
      this.info = { ...info }
    },
    clear() {
      setTimeout(() => {
        this.infoUpdate = {
          id: '',
          status: 1
        }
      }, 500)
    },
    cancle() {
      this.isShow = false
      this.clear()
    },
    confirm() {
      // TODO : get uploaded url
      try {
        this.infoUpdate.id = this.info.id

        if (this.info.statusName == 'Normal') this.infoUpdate.status = 1
        else if (this.info.statusName == 'Admin') this.infoUpdate.status = 2
        else if (this.info.statusName == 'Blind') this.infoUpdate.status = 3

        apiUser.update(this.infoUpdate).then(() => {
          this.onComplete()
        })

        this.isShow = false
        this.clear()
      } catch {}
    },
    closeModal() {
      this.clear()
    }
  }
}
</script>
